import React, { useContext, useState, useEffect } from 'react';
import { AppContext } from './App';
import axios from 'axios';
import { SERVER_URL } from './config';
import './Expenses.css';

const ExpenseEditPopup = ({ expense, onSave, onClose }) => {
    const [editedExpense, setEditedExpense] = useState(expense);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setEditedExpense((prev) => ({ ...prev, [name]: value }));
    };

    const handleSave = () => {
        onSave(editedExpense);
        onClose();
    };

    return (
      <div className="popup-overlay">
          <div className="popup-content">
              <h2>ערוך הוצאה</h2>
              <div className="user-box">
                  <input
                      type="text"
                      name="name"
                      value={editedExpense.name || ''}
                      onChange={handleChange}
                      placeholder="שם ההוצאה"
                  />
              </div>
              <div className="user-box">
                  <input
                      type="number"
                      name="cost"
                      value={editedExpense.cost || ''}
                      onChange={handleChange}
                      placeholder="עלות"
                  />
              </div>
              <button className="login-button" onClick={handleSave}>שמור</button>
              <button className="login-button" onClick={onClose}>בטל</button>
          </div>
      </div>
  );
};

const Expenses = () => {
  const { user } = useContext(AppContext);
  const [expenses, setExpenses] = useState([]);
  const [newExpense, setNewExpense] = useState({ name: '', cost: '' });
  const [editExpense, setEditExpense] = useState(null);
  const [showPopup, setShowPopup] = useState(false);

  const fetchExpenses = async () => {
    try {
        const response = await axios.get(`${SERVER_URL}expenses/`, {
            headers: { Authorization: `Token ${localStorage.getItem('token')}` },
        });
        setExpenses(response.data);
    } catch (error) {
        console.error('Error fetching expenses:', error);
    }
  };

  const downloadExpenses = async () => {
    try {
        const response = await axios.get(`${SERVER_URL}export-expenses/`, {
            headers: { Authorization: `Token ${localStorage.getItem('token')}` },
            responseType: 'blob',
        });

        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'expenses.xlsx');
        document.body.appendChild(link);
        link.click();
    } catch (error) {
        console.error('Error downloading expenses:', error);
    }
  };

  const saveExpense = async (expenseData) => {
    const payload = {
      name: expenseData.name,
      cost: parseFloat(expenseData.cost),
    };

    try {
      if (expenseData.id) {
        await axios.put(`${SERVER_URL}expenses/${expenseData.id}/`, payload, {
          headers: { Authorization: `Token ${localStorage.getItem('token')}` },
        });
      } else {
        await axios.post(`${SERVER_URL}expenses/`, payload, {
          headers: { Authorization: `Token ${localStorage.getItem('token')}` },
        });
      }
      fetchExpenses();
      setNewExpense({ name: '', cost: '' });
      setEditExpense(null);
      setShowPopup(false);
    } catch (error) {
      console.error('Error saving expense:', error);
    }
  };

  const deleteExpense = async (expenseId) => {
    const isConfirmed = window.confirm('האם אתה בטוח שברצונך למחוק את ההוצאה?');
    if (isConfirmed) {
        try {
            await axios.delete(`${SERVER_URL}expenses/${expenseId}/`, {
                headers: { Authorization: `Token ${localStorage.getItem('token')}` },
            });
            setExpenses(expenses.filter((expense) => expense.id !== expenseId));
        } catch (error) {
            console.error('Error deleting expense:', error);
        }
    }
  };

  useEffect(() => {
    fetchExpenses();
  }, []);

  const calculateTotal = () => {
    return expenses.reduce((sum, expense) => sum + expense.cost, 0);
  };

  const handleEdit = (expense) => {
    setEditExpense(expense);
    setShowPopup(true);
  };

  return (
    <div className="expenses-container">
        <h2>ניהול הוצאות חתונה</h2>
      <p>
        זהו דף לניהול ההוצאות לקראת החתונה. פה תוכלו להוסיף הוצאות ועלויות ולעקוב אחרי המחיר הכללי של החתונה.
      </p>
        <div className="form-container">
            <h3>{editExpense ? 'ערוך הוצאה' : 'הוסף הוצאה'}</h3>
            <form
                onSubmit={(e) => {
                    e.preventDefault();
                    saveExpense(newExpense);
                }}
            >
                <input
                    type="text"
                    placeholder="שם ההוצאה"
                    value={newExpense.name}
                    onChange={(e) => setNewExpense({ ...newExpense, name: e.target.value })}
                    required
                />
                <input
                    type="number"
                    placeholder="עלות"
                    value={newExpense.cost}
                    onChange={(e) => setNewExpense({ ...newExpense, cost: e.target.value })}
                    required
                />
                <button type="submit" className="form-submit-button">הוסף</button>
            </form>
        </div>
        <div>
        <table className="expenses-table">
            <thead>
                <tr>
                    <th>שם ההוצאה</th>
                    <th>עלות</th>
                    <th>פעולות</th>
                </tr>
            </thead>
            <tbody>
                {expenses.map((expense) => (
                    <tr key={expense.id}>
                        <td>{expense.name}</td>
                        <td>{expense.cost.toLocaleString()} ש"ח</td>
                        <td>
                            <button onClick={() => handleEdit(expense)}>ערוך</button>
                            <button onClick={() => deleteExpense(expense.id)}>מחק</button>
                        </td>
                    </tr>
                ))}
            </tbody>
        </table>
        </div>

        <div className="total-expenses">
        <h3>סה"כ עלות: {calculateTotal().toLocaleString()} ₪</h3>
        </div>

        <button onClick={downloadExpenses} className='downloadbutton'>הורד כקובץ Excel</button>

        {showPopup && (
            <ExpenseEditPopup
                expense={editExpense}
                onSave={saveExpense}
                onClose={() => setShowPopup(false)}
            />
        )}
    </div>
  );
};

export default Expenses;
